var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAirplayGradientShadow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 64,
    viewBox: "0 0 72 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6070_4689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.3985 44.8001L34.3997 36.7945C35.1997 35.7273 36.8003 35.7273 37.6003 36.7945L43.6015 44.8001C44.5899 46.1186 43.6491 47.9997 42.0012 47.9997H29.9988C28.3509 47.9997 27.4101 46.1186 28.3985 44.8001Z",
    fill: "url(#paint0_linear_6070_4689)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5174 16H44.4826C46.0925 16 47.4213 16 48.5037 16.0884C49.6278 16.1802 50.6613 16.3774 51.6319 16.872C53.1372 17.6389 54.3611 18.8628 55.1281 20.3681C55.6226 21.3387 55.8198 22.3722 55.9116 23.4963C56 24.5787 56 25.9074 56 27.5174V34C56 38.4183 52.4183 42 48 42C46.8954 42 46 41.1046 46 40C46 38.8954 46.8954 38 48 38C50.2091 38 52 36.2091 52 34V27.6C52 25.8868 51.9984 24.7223 51.9249 23.8221C51.8533 22.9452 51.7234 22.4968 51.564 22.184C51.1805 21.4314 50.5686 20.8195 49.816 20.436C49.5032 20.2766 49.0548 20.1467 48.1779 20.0751C47.2777 20.0016 46.1132 20 44.4 20L27.6 20C25.8868 20 24.7223 20.0016 23.8221 20.0751C22.9452 20.1467 22.4968 20.2766 22.184 20.436C21.4314 20.8195 20.8195 21.4314 20.436 22.184C20.2766 22.4968 20.1467 22.9452 20.0751 23.8221C20.0016 24.7223 20 25.8868 20 27.6L20 34C20 36.2091 21.7909 38 24 38C25.1046 38 26 38.8954 26 40C26 41.1046 25.1046 42 24 42C19.5817 42 16 38.4183 16 34L16 27.5174C16 25.9075 16 24.5787 16.0884 23.4963C16.1802 22.3722 16.3774 21.3387 16.8719 20.3681C17.6389 18.8628 18.8628 17.6389 20.3681 16.8719C21.3387 16.3774 22.3722 16.1802 23.4963 16.0884C24.5787 16 25.9075 16 27.5174 16Z",
    fill: "url(#paint1_linear_6070_4689)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6070_4689",
    x: 0,
    y: 0,
    width: 72,
    height: 63.9997,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.192157 0 0 0 0 0.847059 0 0 0 0 0.74902 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6070_4689"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6070_4689",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6070_4689",
    x1: 20.8571,
    y1: 12.2667,
    x2: 41.7321,
    y2: 66.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31D8BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0965F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6070_4689",
    x1: 20.8571,
    y1: 12.2667,
    x2: 41.7321,
    y2: 66.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31D8BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0965F1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplayGradientShadow);
export default __webpack_public_path__ + "static/media/airplay-gradient-shadow.bef38ded3a14b2bf63d588bdb1bf10dd.svg";
export { ForwardRef as ReactComponent };